import React, { useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { FaSave, FaTrash } from "react-icons/fa";
import { updateMessageById } from "../services/APIClient";

function MessageCard({ message, updatedBy, onDelete, onSaved, onError }) {
  const [text, setText] = useState(message.text || "");
  const [link, setLink] = useState(message.hyperlink || message.route || "");
  const [active, setActive] = useState(typeof message.active === "boolean" ? message.active : true);
  const [saving, setSaving] = useState(false);

  const isExternal = (val) => val.startsWith("http");

  const handleSave = async () => {
    setSaving(true);
    try {
      const payload = {
        text,
        active,
        updated_by: updatedBy,
        date_updated: new Date().toISOString(),
      };
      if (isExternal(link)) {
        payload.hyperlink = link;
        payload.route = "";
      } else {
        payload.route = link;
        payload.hyperlink = "";
      }
      await updateMessageById(message.id, payload);
      if (onSaved) onSaved();
    } catch (err) {
      console.error("Failed to save:", err);
      const details = err?.response?.data;
      console.error("Response data:", details);
      if (onError) onError(JSON.stringify(details, null, 2));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="mb-3">
      <Card.Header className="bg-primary text-white">
        <h5 className="mb-0">{message.message_id}</h5>
      </Card.Header>
      <Card.Body>
        <Form.Group className="mb-3">
          <Form.Label className="fw-bold">Message Text</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={text}
            onChange={(e) => setText(e.target.value)} />
        </Form.Group>

        <Form.Group className="mb-3">
          <div className="d-flex align-items-center">
            <Form.Check
              type="switch"
              id={`active-switch-${message.id}`}
              label={active ? "Active" : "Inactive"}
              checked={active}
              onChange={(e) => setActive(e.target.checked)}
            />
          </div>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label className="fw-bold">Link / Route</Form.Label>
          <Form.Control
            value={link}
            onChange={(e) => setLink(e.target.value)}
            placeholder="https://example.com or /beforescreening" />
          {isExternal(link) && (
            <Form.Text className="text-muted">External website detected</Form.Text>
          )}
        </Form.Group>

        {text.trim() && (
          <div
            className="p-3 rounded text-center text-white fw-bold mb-3"
            style={{ backgroundColor: "#e8751a", textTransform: "uppercase", whiteSpace: "pre-wrap" }}
          >
            {text}
          </div>
        )}

        <div className="d-flex justify-content-between">
          <Button variant="primary" onClick={handleSave} disabled={saving}>
            <FaSave className="me-2" />
            {saving ? "Saving..." : "Save Changes"}
          </Button>
          <Button variant="danger" onClick={() => onDelete(message.id)}>
            <FaTrash className="me-2" />Delete
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}

export default MessageCard;
